import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withStyles } from "@material-ui/core/styles";
import styled from 'styled-components';
import moment from "moment";
import { updatePropertyAssumptions } from "store/state/deal";
import { saveCustomProjection } from "store/state/property";
import {Button, Radio, FormControlLabel, TextField, Select, MenuItem , Grid} from "@material-ui/core";
import {Forward, Close, Check, ArrowDownward} from '@material-ui/icons';
import _ from "lodash";
import { styles } from "./ProjectionStyle";
import MaterialDatePicker from "material-ui-pickers/DatePicker";
import {
    TwoDecimalPercentFormat,
    DollarAndCentFormat,
    FloatFormat,
} from 'components/Notifications/FormattedInputs';
import SimpleInfoDialog from 'components/Global/ConfirmationDialogs/SimpleInfoDialog';
import numberFormatter from 'utils/numberFormatter';
import { downloadProjections, clearExtractedProjections } from "../../../store/state/properties";
import UploadSpreadsheetModal from "./UploadSpreadsheetModal";

const Months = {
    0: "Jan",
    1: "Feb",
    2: "Mar",
    3: "April",
    4: "May",
    5: "June",
    6: "July",
    7: "Aug",
    8: "Sept",
    9: "Oct",
    10: "Nov",
    11: "Dec", 
};

const Quarters = {
    0: 1,
    1: 1,
    2: 1,
    3: 2,
    4: 2,
    5: 2,
    6: 3,
    7: 3,
    8: 3,
    9: 4,
    10:4,
    11:4,
}

const getHyphenIfAutoOrNothingIfCustom = (mode) => {
    if(mode.toLowerCase === "auto"){
        return "-";
    }else{
        return ""
    }
}

const DashContainer = styled.div`
    margin-top: 50px;
    margin-bottom: 20px;
    width: 70%;
    min-width: 1250px;
`;

const BlueButton = styled(Button)`
  &&{
    color:#2196f3
    :hover {
        background-color: rgba(0,0,0,0);
    }
  }
`;

const StyledTextField = styled(TextField)`
  max-width:100px;
`;


const Title = styled.p`
    font-size: 16pt;
    color: #999999;
    width: 100%;
    margin-bottom: 4px;
    padding-right: 0px;
`;

const SmallRightAlignedSpan = styled.span`
  float: right;
  font-size: 12pt;
`;

const MediumBlueSpan = styled.span`
  color: #2196f3;
  font-size: 11pt;
`;

const ClickableSpan = styled.span`
    cursor: pointer;
`;

const BlueArrow = styled(Forward)`
    margin-bottom: -5px;
    margin-left: 10px;
    color: #2196f3;
    cursor: pointer;
`;
const GreenArrowMarker = styled(ArrowDownward)`
    margin-bottom: -10px;
    color: #4cd964;
    position: relative;
    right: 90px;
`;
const BlueX = styled(Close)`
    margin-bottom: -7px;
    color: #2196f3;
`;

const BlueCheck = styled(Check)`
    margin-bottom: -7px;
    color: #2196f3;
`;

const GrayDiv = styled.div`
    &&{
        min-height: 60px;
        width: 98%;
        background-color: #eeeeee;
        color: #777777;
        border-radius: 4px;
        padding-left: 15px;
        padding-top: 8px;
        vertical-align: middle;
    }
`;

const GrayFormControlLabel = styled(FormControlLabel)`
    &&{
        color: #777777;
    }
`;

const TableContainerLeft = styled.div`
    min-height: 100px;
    overflow-x: show;
    display: inline-block;
    min-width: 30%;
    vertical-align: top;
`;

const TableContainerRight = styled.div`
    min-height: 100px;
    height:100%;
    overflow-x: auto;
    display: inline-block;
    width: 70%
    vertical-align: top;
`;

const TableContainerOuter = styled.div`
    width: 100%;
    vertical-align: top;
    white-space: nowrap;
`;

const MainTable = styled.table`
    border-collapse: collapse;
    margin-top: 20px;
`;

const StyledTableRow = styled.tr`
`;

const StyledTableCell = styled.td`
    &&{
        min-width: 100px;
        min-height: 20px;
        padding: 10px;
        text-align: center;
        white-space: nowrap;
        width: auto;
    }
`;

const StyledTableHead = styled.th`
    min-width: 100px;
    min-height: 20px;
    padding: 10px;
`;

const StyledTableHeadAlt = styled.th`
    min-width: 100px;
    min-height: 20px;
    padding: 10px;
    left: 10px;
    position: relative;
`;

const StyledOptionsGrid = styled(Grid)`
    &&{
        margin-top: 8px;
    }
`;

export class PropertyProjectionDashboard extends Component {

    getPeriodType(periodValue){
        const val = parseFloat(periodValue);
        switch (val){
            case 0: 
                return {name: "", value: 0};
            case 1:
                return {name: "monthly" , value: 1};
            case 3:
                return {name: "quarterly" , value: 3};
            case 12:
                return {name: "annual" , value: 12};
        }
    }

    componentDidMount(){
        const property = this.props.property;
        const projections = this.props.projections;
        let term = projections[0] ? projections[0].termAssumption : property.termAssumption;
        this.setState({asOfDate: projections[0] ? new Date(projections[0].asOfDate) : new Date()});
        if(!term) term = 10;
        let mode = property.isAutoProjectionCalculation ? "auto" : "custom";
        let periodType = projections[0] ? this.getPeriodType(projections[0].periodTypeAssumption) : 
            mode==="auto" ? this.getPeriodType(12) : this.getPeriodType(property.periodTypeAssumption);
        if(!periodType) {
            periodType = this.getPeriodType(12);
        }

        if(!property.capRateAssumption && property.marketValue )
            property.capRateAssumption = (property.noiActual || 0) / property.marketValue;
        
        if(!property.occupancyAssumption && property.occupancy)
            property.occupancyAssumption = (property.occupancy / 100);

        this.setState({mode, periodType});
        if(!projections || projections.length === 0){
            for (let i =0; i < term; i++){
                if(property.capRateAssumption)
                    this.state.gridValues.capRate[i] = (property.capRateAssumption*100).toFixed(2);

                if(property.occupancyAssumption)
                    this.state.gridValues.occupancy[i] = (property.occupancyAssumption*100).toFixed(2);
                
                if(property.noiActualBumpAssumption)
                    this.state.gridValues.noiActual[i] = this.getCompounding(property.noiActual, property.noiActualBumpAssumption, i);
                
                if(property.noiLenderBumpAssumption)
                    this.state.gridValues.noiLender[i] = this.getCompounding(property.noi, property.noiLenderBumpAssumption, i);
                
                // this.setState({gridValues:this.state.gridValues});
            }
        }else{
            let term = 0;
            if(projections && projections.length > 0) {
                for(let i = this.findStartingIndex(periodType, projections) ; i < projections.length; i+= periodType.value){
                    if(!projections[i]) break;
                    this.state.gridValues.capRate[term] = (projections[i].capRate * 100);
                    this.state.gridValues.occupancy[term] = (projections[i].occupancy * 100);
                    this.state.gridValues.noiActual[term] = projections[i].noiActual;
                    this.state.gridValues.noiLender[term] = projections[i].noiLender;
                    this.state.gridValues.dscrLender[term] = projections[i].dscrLender;
                    this.state.gridValues.debtYield[term] = projections[i].debtYield;
                    this.state.gridValues.isAugmented[term] = projections[i].loanProceedAssumptionId != null;
                    term++;
                }
            }
            this.setState({term})
        }
    }

  componentDidUpdate() {
    if (this.state.loadExtraction && this.props.extractedProjections) {
      const gridValues = { capRate: [], occupancy: [], noiActual: [], noiLender: [], dscrLender: [], debtYield: [], isAugmented: []};
      // eslint-disable-next-line no-restricted-syntax
      for (const extractedProjection of this.props.extractedProjections) {
        gridValues.capRate.push(extractedProjection.capRate * 100);
        gridValues.occupancy.push(extractedProjection.occupancy * 100);
        gridValues.noiActual.push(extractedProjection.noiActual);
        gridValues.noiLender.push(extractedProjection.noiLender);
        gridValues.dscrLender.push(extractedProjection.dscrLender);
        gridValues.debtYield.push(extractedProjection.debtYield);
        gridValues.isAugmented.push(extractedProjection.isAugmented);
      }
      this.props.clearExtractedProjections();
      this.setState({ loadExtraction: false, gridValues });
    }
  }

    getPeriodYearOfRecord(record){
        return parseFloat(record.periodDate.split("-")[0]);
    }
    getPeriodMonthOfRecord(record){
        return parseFloat(record.periodDate.split("-")[1]) - 1;
    }
    getPeriodQuarterOfRecord(record){
        return Quarters[this.getPeriodMonthOfRecord(record)];
    }


    findStartingIndex = (periodType, projections) => {
        if(!projections[0])return 0;
        let i =0;
        switch(periodType.value){
            case 1: return 0;
            case 3: 
                let startQuarter = this.getPeriodQuarterOfRecord(projections[0]);
                while(projections[i+1] && this.getPeriodQuarterOfRecord(projections[i+1]) === startQuarter){
                    let currentQ = this.getPeriodQuarterOfRecord(projections[i+1]);
                    i++;
                }
                return i;
            case 12:
                let startYear = this.getPeriodYearOfRecord(projections[0]);
                while(projections[i+1] && this.getPeriodYearOfRecord(projections[i+1]) <= startYear){
                    i++;
                }
                return i;
        }
    }


    state = {
        currentAssumptions: {
            capRate: null,
            occupancy: null, 
            noiActual: null,
            noiLender: null,
            dscrLender: null,
            debtYield: null,
        },
        defaultAssumptions: {
            capRate: null,
            occupancy: null, 
            noiActual: .03,
            noiLender: .03,
            dscrLender: null,
            debtYield: null,
        },
        gridValues : {
            capRate : [],
            occupancy : [],
            noiActual : [],
            noiLender : [],
            dscrLender: [],
            debtYield: [],
            isAugmented: [],
        },
        enabled : false,
        mode : "auto",
        periodType: {name:"annual", value:12},
        term: 10,
        asOfDate: new Date(),
        projections: null,
        selectedDate: this.props.isPipeline ? new Date() : null,  
        dialogOpen: false,
        monthOffset: 0,
    };

    standardizeFormattedNumber = (value) => {
        let convertedValue = 0;
        if(typeof value === "string"){
            if(value.length > 1){
                if(value.includes("%")){
                    convertedValue = parseFloat(value.substring(0, value.length-1));
                }
                if(value.includes("$")){
                    convertedValue = parseFloat(value.replace(/,/g,"").substring(1, value.length));
                }
            } else{
                return undefined;
            }
        }
        if(convertedValue > 999999999999){
            convertedValue = 999999999999; //max number the db can hold
        }
        return convertedValue || parseFloat(value);
    }
    
    save = () => {
        if(this.state.mode=="custom" && (!this.state.selectedDate || !this.state.asOfDate)){
            this.setState({dialogOpen:true, errorMessage:"As Of Date Required"})
            return;
        }
        if(this.state.mode=="custom" && (this.state.asOfDate > new Date())){
            this.setState({dialogOpen:true, errorMessage:"As of date must not be in the future"})
            return;
        }
        const property = this.props.property;
        const assumptions = this.state.currentAssumptions;
        if(this.state.mode == "auto"){
            this.props.updatePropertyAssumptions({
                propertyId: property.id,
                capRateAssumption: assumptions.capRate,
                occupancyAssumption: assumptions.occupancy,
                noiActualAssumption: assumptions.noiActual,
                noiLenderAssumption: assumptions.noiLender,
                periodType : this.state.periodType.value,
                term: this.state.term,
                isAuto : this.state.mode == "auto",
            });   
            if(assumptions.capRate)this.carryOverCapRate((assumptions.capRate/100).toFixed(2));
            if(assumptions.occupancy)this.carryOverOccupancy((assumptions.occupancy/100).toFixed(2));
            if(assumptions.noiActual)this.carryOverNoiActual(assumptions.noiActual);
            if(assumptions.noiLender)this.carryOverNoiLender(assumptions.noiLender);
        } else {
            this.props.saveCustomProjection({
                gridValues : this.state.gridValues,
                asOfDate : this.state.asOfDate,
                termInPeriod : this.state.term,
                periodType : this.state.periodType,
                propertyId : this.props.property.id,
                assumptions, 
                currentValues: {
                    capRate: (parseFloat(this.getCapRateOfProperty(property))*100).toFixed(2),
                    occupancy: property.occupancy,
                    noiActual: property.noiActual,
                    noiLender: property.noi,
                    dscrLender: property.dscrLender,
                    debtYield: property.debtYield,
                },
                monthOffset: this.state.monthOffset,
                isPipeline: this.props.isPipeline,
                targetedClosing: this.props.targetedClosing,
            });
        }
        this.props.property.capRateAssumption = assumptions.capRate/100;
        this.props.property.occupancyAssumption = assumptions.occupancy/100;
        this.props.property.noiActualBumpAssumption = assumptions.noiActual;
        this.props.property.noiLenderBumpAssumption = assumptions.noiLender;
        this.setState({enabled:false});
        setTimeout(()=>this.props.refreshProjections(),1000);        
    }

    clearGrid = () => {
        this.setState({gridValues : {
            capRate : [],
            occupancy : [],
            noiActual : [],
            noiLender : [],
            dscrLender: [],
            debtYield : [],
            isAugmented : [],
        }});
    }

    carryOverCapRate = (value) => {
        if(value !== null && value !== undefined){
            let gridValues = this.state.gridValues;
            for(let i = 0; i < this.state.term; i++) {
                let scaledValue = value;
                scaledValue *= 100;
                gridValues.capRate[i] = scaledValue;
            }
            this.setState({gridValues});
        }
    }

    carryOverOccupancy = (value) => {
        if(value !== null && value !== undefined){
            let gridValues = this.state.gridValues;
            for(let i = 0; i < this.state.term; i++) {
                let scaledValue = value;
                scaledValue *= 100;
                gridValues.occupancy[i] = scaledValue;
            }
            this.setState({gridValues});
        }
    }

    carryOverNoiActual = (value) => {
        if(value !== null && value !== undefined){
            if(typeof value === "string") value = parseFloat(value);
            let gridValues = this.state.gridValues;
            let principle = this.props.property.noiActual;
            let currentMonth = this.state.asOfDate.getMonth();
            for(let i = 0; i < this.state.term; i++) {
                if(i===0){
                    gridValues.noiActual[i] = this.getCompounding(principle, value, 11-currentMonth, (1/12));
                    principle = gridValues.noiActual[i];
                }else{
                    gridValues.noiActual[i] = this.getCompounding(principle, value, 1);
                    principle = gridValues.noiActual[i];
                }
            }
            this.setState({gridValues});
        }
    }

    carryOverNoiLender = (value) => {
        if(value !== null && value !== undefined){
            if(typeof value === "string") value = parseFloat(value);
            let gridValues = this.state.gridValues;
            let principle = this.props.property.noi;
            let currentMonth = this.state.asOfDate.getMonth();
            for(let i = 0; i < this.state.term; i++) {
                if(i===0){
                    gridValues.noiLender[i] = this.getCompounding(principle, value, 11-currentMonth, (1/12));
                    principle = gridValues.noiLender[i];
                }else{
                    gridValues.noiLender[i] = this.getCompounding(principle, value, 1);
                    principle = gridValues.noiLender[i];
                }
            }
            this.setState({gridValues});
        }
    }

    getCompounding = (principle, percent, index, compilationMultiplier) => {
        if(!compilationMultiplier) compilationMultiplier = 1; //1 = year for default
        if(typeof principle === "string") principle = parseFloat(principle);
        if(typeof percent === "string") percent = parseFloat(percent);
        let multiplier = Math.pow((percent + 1), (index)*compilationMultiplier);
        let result = principle * multiplier;
        return result;
    }
    
    getCapRateOfProperty = (property) => {
        if(!property.noiActual || !property.marketValue || property.marketValue==0){
            return null;
        }else{
            return (property.noiActual / property.marketValue).toFixed(4);
        }
    }

  onUploadSpreadsheetModalClose = loadExtraction => {
    this.setState({ loadExtraction, uploadSpreadsheetModalOpen: false });
  };

    render(){
        const property = this.props.property;
        const enabled = this.state.enabled;
        const mode = this.state.mode.toLowerCase();
        const projections = this.props.projections;
        let formattedLastAsOfDate = projections && projections[0] ? projections[0].asOfDate : null;
        if(formattedLastAsOfDate){
            const parts = formattedLastAsOfDate.split("-");
            formattedLastAsOfDate = parts[1]+"/"+parts[2]+"/"+parts[0];
        }
        return( 
        <DashContainer>
            <UploadSpreadsheetModal
              isOpen={this.state.uploadSpreadsheetModalOpen}
              onClose={this.onUploadSpreadsheetModalClose}
              propertyDisplayName={ `${property.name} - ${property.address}` }
              propertyId={ property.id }
              asOfDate={ this.state.selectedDate }
              periodType={ this.state.periodType.value }
              term={ this.state.term }
            />
            <SimpleInfoDialog 
                modalOpen = {this.state.dialogOpen}
                title = {this.state.errorMessage}
                handleClose = {()=>this.setState({dialogOpen:false})}
                handleAccept = {()=>this.setState({dialogOpen:false})}
            />
            <Title>{`${property.name} - ${property.address}`}
            <SmallRightAlignedSpan>
            {!this.props.isPipeline &&  
                <span style={{fontStyle: "italic",marginRight: enabled ? "20px" : ""}}>{`Last Projection As Of: ${ formattedLastAsOfDate || "None"}`}</span>
            }
            {this.props.isPipeline &&
                 <span style={{fontStyle: "italic",marginRight: enabled ? "20px" : ""}}>{`Targeted Close Date Of: ${ moment.utc(this.props.targetedClosing).format("MM/DD/YYYY") || "None"}`}</span>
            }
                {
                    enabled && 
                    <MediumBlueSpan style={{marginRight:"15px"}}>
                        <ClickableSpan onClick = {()=>{
                            this.setState({enabled:!enabled})
                            this.componentDidMount();
                            }}>
                            <BlueX/> CANCEL
                        </ClickableSpan>
                        <span style={{color:"#999999", fontSize: "16pt", marginLeft:"7px", marginRight:"7px"}}>{"\u007C"}</span>
                        <ClickableSpan onClick = {this.save}>
                            <BlueCheck/> SAVE
                        </ClickableSpan>
                    </MediumBlueSpan>
                }
                {
                    !enabled && this.hasEditAccess() && 
                    <BlueButton onClick = {()=>{
                        this.setState({enabled:!enabled})
                        let defaultAssumptions = {
                            capRate: this.getCapRateOfProperty(property) ? this.getCapRateOfProperty(property)*100 : 0,
                            occupancy : property.occupancy ? property.occupancy : 0,
                            noiActual : .03,
                            noiLender : .03,
                        }
                        this.setState({currentAssumptions: defaultAssumptions, defaultAssumptions, asOfDate:new Date()});
                        this.setState({gridValues : {capRate:[], occupancy: [], noiActual: [], noiLender: [], dscrLender: [], debtYield: [], isAugmented: []}, selectedDate: this.props.isPipeline ? new Date() : null})
                        if(this.state.mode == "auto"){
                            this.setState({periodType: this.getPeriodType(12), term: 10});
                        } else if (this.state.mode == "custom"){
                            this.setState({periodType: this.getPeriodType(0), term: null});
                        }
                        }}>
                    UPDATE
                    </BlueButton>
                }
                
            </SmallRightAlignedSpan>
            </Title>
            <GrayDiv>
                <Grid container>
                    <Grid item xs={3}>
                        <GrayFormControlLabel
                            label = "Auto-Calculate"
                            classes={{
                                label: enabled ? this.props.classes.darkGray : this.props.classes.gray,                       
                            }}
                            control = {
                            <Radio 
                            checked = {this.state.mode.toLowerCase()=="auto"}
                            onClick = {() => {
                                if(!enabled) return;
                                this.clearGrid();
                                this.setState({
                                    mode:"auto",
                                    term:10,
                                    periodType: {name:"annual", value:12},
                                    asOfDate: new Date(),
                                });
                            }}
                            />
                            }
                        />
                        <GrayFormControlLabel
                            label = "Custom"
                            classes={{
                                label: enabled ? this.props.classes.darkGray : this.props.classes.gray,                       
                            }}
                            control = {
                            <Radio 
                            checked = {this.state.mode.toLowerCase()=="custom"}
                            onClick = {() => {
                                if(!enabled) return;
                                this.clearGrid();
                                this.setState({mode:"custom"});
                                this.setState({periodType: this.getPeriodType(0), term: null});
                            }}
                            />
                            }
                        />
                    </Grid>
                    
                    <StyledOptionsGrid item xs={7}>
                        {this.renderBannerControls()}
                    </StyledOptionsGrid>

                    <Grid item xs={2}>
                        {!enabled && this.hasEditAccess() &&
                        <BlueButton onClick={() => this.props.downloadProjections(property.id)} style={{position: "sticky", float:"right", marginTop: "7px"}}>
                            DOWNLOAD
                        </BlueButton>
                        }
                        {enabled && mode === "custom" && this.state.selectedDate && this.state.periodType && this.state.periodType.value > 0 && this.state.term &&
                        <BlueButton onClick={() => this.setState({ uploadSpreadsheetModalOpen: true })} style={{float:"right", clear: "both", marginTop: "7px"}}>
                            IMPORT DATA
                        </BlueButton>
                        }
                        {enabled && mode === "custom" && !(this.state.selectedDate && this.state.periodType && this.state.periodType.value > 0 && this.state.term) &&
                        <BlueButton disabled={true} style={{float:"right", clear: "both", marginTop: "7px"}}>
                            IMPORT DATA
                        </BlueButton>
                        }
                    </Grid>

                </Grid>
            </GrayDiv>
            {(!enabled || mode=="auto" || (!!this.state.selectedDate && !!this.state.term && !!this.state.periodType.value>0)) && 
                <Fragment>{this.renderTable({enabled, periodType: this.state.periodType, property, mode})}</Fragment>
            }
           
        </DashContainer >);
    }

    renderTable = ({enabled, periodType, property, mode}) => {
        let capRateAssumption = property.capRateAssumption;
        let occupancyAssumption = property.occupancyAssumption;
        if(capRateAssumption) capRateAssumption = (capRateAssumption*100).toFixed(2);
        if(occupancyAssumption) occupancyAssumption = (occupancyAssumption*100).toFixed(2);
        return (
            <TableContainerOuter>
                <TableContainerLeft style={{marginBotom: this.state.term>7 ? "" : ""}}>
                    <MainTable>
                        <tbody>
                        <StyledTableRow>
                            <StyledTableHead></StyledTableHead>
                            <StyledTableHead>Current</StyledTableHead>
                            <StyledTableHead style={{backgroundColor:"#eeeeee"}}>Assumptions</StyledTableHead>
                        </StyledTableRow>
                        <StyledTableRow>
                            <StyledTableHead>Cap Rate</StyledTableHead>
                            <StyledTableCell>{this.getCapRateOfProperty(property) ? `${(this.getCapRateOfProperty(property)*100).toFixed(2)}%` : "-"}</StyledTableCell>
                            <StyledTableCell style={{backgroundColor:"#eeeeee"}}>
                                {!enabled ? property.capRateAssumption ? `${capRateAssumption}%` : "-" : 
                                <Fragment>
                                    {this.renderInput({
                                        type:"percent",
                                        defaultValue: this.state.defaultAssumptions.capRate,
                                        onChange: (event)=>{
                                            let newAssumptions = this.state.currentAssumptions;
                                            newAssumptions.capRate = event.target.value;
                                            this.setState({currentAssumptions:newAssumptions});
                                        },
                                    })}
                                    <BlueArrow onClick={()=>this.carryOverCapRate((this.state.currentAssumptions.capRate/100).toFixed(4))}/>
                                </Fragment>
                                }
                            </StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                            <StyledTableHead>Occupancy</StyledTableHead>
                            <StyledTableCell>{property.occupancy ? `${property.occupancy.toFixed(2)}%` : "-"}</StyledTableCell>
                            <StyledTableCell style={{backgroundColor:"#eeeeee"}}>
                                {!enabled ? property.occupancyAssumption ? `${occupancyAssumption}%` : "-" : 
                                <Fragment>
                                    {this.renderInput({
                                        type:"percent",
                                        defaultValue: this.state.defaultAssumptions.occupancy,
                                        onChange: (event)=>{
                                            let newAssumptions = this.state.currentAssumptions;
                                            newAssumptions.occupancy = event.target.value;
                                            this.setState({currentAssumptions:newAssumptions});
                                        },
                                    })}
                                    <BlueArrow onClick={()=>this.carryOverOccupancy((this.state.currentAssumptions.occupancy/100).toFixed(4))}/>
                                </Fragment>
                                }
                            </StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                            <StyledTableHead style= {{paddingTop: this.getAssumptionsRowPadding(), paddingBottom: this.getAssumptionsRowPadding()}}>   
                                NOI (Actual)
                            </StyledTableHead>
                            <StyledTableCell>{property.noiActual ? `${numberFormatter.formatMoney(property.noiActual,0)}` : "-"}</StyledTableCell>
                            <StyledTableCell style={{backgroundColor:"#eeeeee"}}>
                                {!enabled ? property.noiActualBumpAssumption  && mode !== "custom" ? `${(property.noiActualBumpAssumption*100).toFixed(2)}%` : getHyphenIfAutoOrNothingIfCustom(mode) : 
                                <Fragment>
                                    {mode=="auto" &&
                                        <Fragment>
                                        {this.renderInput({
                                            type:"percent",
                                            defaultValue: this.state.defaultAssumptions.noiActual * 100,
                                            onChange: (event)=>{
                                                let newAssumptions = this.state.currentAssumptions;
                                                newAssumptions.noiActual = (parseFloat(event.target.value)/100).toFixed(4);
                                                if(isNaN(newAssumptions.noiActual)) newAssumptions.noiActual = 0;
                                                this.setState({currentAssumptions:newAssumptions});
                                            },
                                        })}
                                        <BlueArrow onClick={()=>this.carryOverNoiActual((this.state.currentAssumptions.noiActual))}/>
                                        </Fragment>
                                    }
                                </Fragment>
                                }
                            </StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                            <StyledTableHead style= {{paddingTop: this.getAssumptionsRowPadding(), paddingBottom: this.getAssumptionsRowPadding()}}>
                                NOI (Lender)
                            </StyledTableHead>
                            <StyledTableCell>{property.noi ? `${numberFormatter.formatMoney(property.noi,0)}` : "-"}</StyledTableCell>
                            <StyledTableCell style={{backgroundColor:"#eeeeee"}}>
                                {!enabled ? property.noiLenderBumpAssumption && mode !== "custom" ? `${(property.noiLenderBumpAssumption*100).toFixed(2)}%` : getHyphenIfAutoOrNothingIfCustom(mode) : 
                                <Fragment>
                                    {mode=="auto" &&
                                        <Fragment>
                                        {this.renderInput({
                                            type:"percent",
                                            defaultValue: this.state.defaultAssumptions.noiLender * 100,
                                            onChange: (event)=>{
                                                let newAssumptions = this.state.currentAssumptions;
                                                newAssumptions.noiLender = (parseFloat(event.target.value)/100).toFixed(4);
                                                if(isNaN(newAssumptions.noiLender)) newAssumptions.noiLender = 0;
                                                this.setState({currentAssumptions:newAssumptions});
                                            },
                                        })}
                                        <BlueArrow onClick={()=>this.carryOverNoiLender((this.state.currentAssumptions.noiLender))}/>
                                        </Fragment>
                                    }
                                </Fragment>
                                }
                            </StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                            <StyledTableHead style= {{paddingTop: this.getAssumptionsRowPadding(), paddingBottom: this.getAssumptionsRowPadding()}}>
                                DSCR
                            </StyledTableHead>
                            <StyledTableCell>
                                {property.dscrLender ? `${numberFormatter.formatDecimal(property.dscrLender, 2)}x` : "-"}
                            </StyledTableCell>
                            <StyledTableCell style={{backgroundColor:"#eeeeee"}}>
                                {property.dscrLender ? `${numberFormatter.formatDecimal(property.dscrLender, 2)}x` : "-"}
                            </StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                            <StyledTableHead style= {{paddingTop: this.getAssumptionsRowPadding(), paddingBottom: this.getAssumptionsRowPadding()}}>
                                Debt Yield
                            </StyledTableHead>
                            <StyledTableCell>
                                {property.debtYield ? `${numberFormatter.formatRate(property.debtYield,2)}` : "-"}
                            </StyledTableCell>
                            <StyledTableCell style={{backgroundColor:"#eeeeee"}}>
                                {property.debtYield ? `${numberFormatter.formatRate(property.debtYield,2)}` : "-"}
                            </StyledTableCell>
                        </StyledTableRow>
                        </tbody>
                    </MainTable>
                </TableContainerLeft>
                <TableContainerRight>
                    <MainTable >
                        <tbody>
                            <StyledTableRow>
                                {this.renderDynamicCellHeaders(periodType)}
                            </StyledTableRow>
                            <StyledTableRow >
                                {this.renderDynamicCellsCapRate({padding: this.getRowPadding()})}
                            </StyledTableRow>
                            <StyledTableRow>
                                {this.renderDynamicCellsOccupancy({padding: this.getRowPadding()})}
                            </StyledTableRow>
                            <StyledTableRow>
                                {this.renderDynamicCellsNoiActual({padding: this.getRowPadding()})}
                            </StyledTableRow>
                            <StyledTableRow>
                                {this.renderDynamicCellsNoiLender({padding: this.getRowPadding()})}
                            </StyledTableRow>
                            <StyledTableRow>
                                {this.renderDSCRRow({padding: this.getRowPadding()})}
                            </StyledTableRow>
                            <StyledTableRow>
                                {this.renderDebtYieldRow({padding: this.getRowPadding()})}
                            </StyledTableRow>
                        </tbody>
                    </MainTable>
                </TableContainerRight>
            </TableContainerOuter>
        );
    };

    getRowPadding = () => {
        if(this.state.enabled && this.state.mode == "auto"){
            return "15px";
        }else{
            return "";
        }
    }
    getAssumptionsRowPadding = () => {
        if(this.state.enabled && this.state.mode == "custom"){
            return "15px";
        }else{
            return "";
        }
    }

    renderBannerControls = () => {
        const out = [];
        const enabled = this.state.enabled;
        const periodType = this.state.periodType;
        const mode = this.state.mode;
        let termLabel = "years";
        switch(periodType.value){
            case 12: 
                termLabel = "Years";
                break;
            case 3: 
                termLabel = "Quarters";
                break;
            case 1:
                termLabel = "Months";
                break;
        }
        if(enabled){
            if(mode.toLowerCase() == "custom"){
                out.push(
                    <FormControlLabel 
                        style = {{marginLeft: "5px"}}
                        label = "As Of Date:"
                        labelPlacement = "start"
                        control = {
                            <MaterialDatePicker
                                format = "MM/DD/YYYY"
                                value = {this.state.selectedDate}
                                style = {{width: "100px", marginLeft: "20px", backgroundColor: "white"}}
                                onChange = { event => {
                                    this.setState({asOfDate: event._d, selectedDate: event});
                                }}
                            />
                        }
                    />
                );
                out.push(
                    <FormControlLabel 
                        style = {{marginLeft: "0"}}
                        label = "Period Type:"
                        labelPlacement = "start"
                        control = {
                            <Select 
                                style = {{marginLeft: "20px", backgroundColor: "white", minWidth: "100px"}}
                                value = {this.state.periodType.value}
                                onChange = {event => {
                                    this.setState({periodType: this.getPeriodType(event.target.value)})
                                }}
                            >
                                <MenuItem value={12}>Annual</MenuItem>
                                <MenuItem value={3}>Quarterly</MenuItem>
                                <MenuItem value={1}>Monthly</MenuItem>
                            </Select>
                            
                        }
                    />
                );
            }
            out.push(
            <FormControlLabel 
                style = {{marginLeft: mode=="custom" ? "0" : "50px"}}
                label = {periodType.value > 0 ? `Term (${termLabel}):` : "Term:"}
                labelPlacement = "start"
                control = {
                    this.renderInput({
                        type : "integer",
                        style : {marginLeft: "5px", backgroundColor: "white"},
                        value : this.state.term,
                        onChange : event =>{
                            const proposedChange = event.target.value;
                            if(proposedChange > 0 && proposedChange < 361){ //360 is max number of columns (30yrs worth of months)
                                this.setState({term:proposedChange});
                            }
                        },
                    })
                }
            />
            );
        }
        return out;
    }

    applyMonthOffsetToStateForQuarter = (month) => {
        let offset = 0;
        let todaysQ = Quarters[month];
            if(todaysQ == 4){
                offset=3;
                if(this.state.monthOffset !== offset){
                    this.setState({monthOffset:offset});
                }                
            }
    }

    renderDynamicCellHeaders = (periodType) => {
        const out = [];
        let year;
        let month;
        if(periodType.name.toLowerCase() == "annual"){
            let ydate = this.state.asOfDate || new Date();
            if(this.props.isPipeline && this.props.targetedClosing) ydate = this.props.targetedClosing;
            if(!this.state.enabled && this.props.projections[0]) ydate = new Date(this.props.projections[0].periodDate);
            year = ydate.getFullYear();
            month = ydate.getMonth();
            if(this.state.asOfDate.getMonth() == 11) { //if its december, dont use current year
               month=0
               year = this.state.asOfDate.getFullYear() + 1;
               if(this.state.monthOffset!=12){          //12 month offset because since its december of one year annually, we actually mean
                    this.setState({monthOffset:12});    //december of the following year
                }
            }
            for(let i = 0; i < this.state.term; i++){

                let showMarker = this.state.gridValues.isAugmented && i === 0 && this.state.gridValues.isAugmented[i];

                if(!showMarker){
                    const prevPeriodCheck = this.state.gridValues.isAugmented && (i > 0 && this.state.gridValues.isAugmented[i-1]);
                    const currentPeriod = this.state.gridValues.isAugmented && this.state.gridValues.isAugmented[i];
                    showMarker = !prevPeriodCheck && currentPeriod;
                }

                if(showMarker)
                    out.push(<StyledTableHeadAlt>{year}{showMarker ? <GreenArrowMarker />: ""}</StyledTableHeadAlt>);
                else
                    out.push(<StyledTableHead>{year}</StyledTableHead>);

                year++;
            }
        }else if (periodType.name.toLowerCase() == "quarterly"){
            let qDate = this.state.asOfDate || new Date();
            if(this.props.isPipeline && this.props.targetedClosing) qDate = this.props.targetedClosing;
            if(!this.state.enabled && this.props.projections[0]) qDate = new Date(this.props.projections[0].periodDate);
            year = qDate.getFullYear();
            month = qDate.getMonth();
            this.applyMonthOffsetToStateForQuarter();
            let todaysQ = Quarters[month];
            if(todaysQ == 4){
                while(Quarters[month] === todaysQ){
                    month++;        //skip this quarter when starting a new one
                }
            }
            if(month>11){
                month=0;
                year++;
            }
            let startIndex = 0;
            let numColumns = this.state.term;
            for(let i = startIndex; i < numColumns; i++){
                out.push(<StyledTableHead>{`Q${Quarters[month]} ${year}`}</StyledTableHead>)
                month+=3;
                if(month > 11){ 
                    month = 0;
                    year++;
                }
            }
        } else if (periodType.name.toLowerCase() == "monthly"){
            let mdate = this.state.asOfDate || new Date();
            if(this.props.isPipeline && this.props.targetedClosing) mdate = this.props.targetedClosing;
            if(!this.state.enabled && this.props.projections[0]) mdate = new Date(this.props.projections[0].periodDate);
            year = mdate.getFullYear();
            month = mdate.getMonth();
            month++; //dont do current month when starting a new one
            let startIndex = 0;
            let numColumns = this.state.term;
            for(let i = startIndex; i < numColumns; i++){
                out.push(<StyledTableHead>{`${Months[month]} ${year}`}</StyledTableHead>)
                month++;
                if(month > 11){ 
                    month = 0;
                    year++;
                }
            }
        }
        
        return out;
    }

    renderDynamicCellsCapRate = ({padding}) => {
        padding = padding || "";
        const out = [];
        const periodType = this.state.periodType;
        const enabled = this.state.enabled;
        const mode = this.state.mode;
        let numColumns = this.state.term;
        for(let i = 0; i < numColumns; i++){
            if(mode.toLowerCase() == "auto"){
                out.push(
                    <StyledTableCell style={{paddingTop: padding, paddingBottom: padding}}>
                        {`${this.state.gridValues.capRate[i] ? `${parseFloat(this.state.gridValues.capRate[i]).toFixed(2)}%` : "-" }`}
                    </StyledTableCell>
                );
            } else if (mode == "custom"){
                if (enabled) {
                    out.push(
                        <StyledTableCell>
                            {this.renderInput({
                            type:"percent",
                            value: this.state.gridValues.capRate[i],
                            onBlur: (event)=>{
                                this.state.gridValues.capRate[i] = this.standardizeFormattedNumber(event.target.value); 
                                this.setState({gridValues: this.state.gridValues});
                            }
                            })}
                        </StyledTableCell>
                    );
                } else {
                    out.push(
                    <StyledTableCell>
                        {`${this.state.gridValues.capRate[i] ? `${(this.state.gridValues.capRate[i]).toFixed(2)}%` : "-" }`}
                    </StyledTableCell>
                    );
                }
            }
        }
        return out;
    }

    renderDynamicCellsOccupancy = ({padding}) => {
        padding = padding || "";
        const out = [];
        const periodType = this.state.periodType;
        const enabled = this.state.enabled;
        const mode = this.state.mode;
        let numColumns = this.state.term;
        for(let i = 0; i < numColumns; i++){
            if(mode.toLowerCase() == "auto"){
                out.push(
                    <StyledTableCell style={{paddingTop: padding, paddingBottom: padding}}>
                        {`${this.state.gridValues.occupancy[i] ? `${parseFloat(this.state.gridValues.occupancy[i]).toFixed(2)}%` : "-" }`}
                    </StyledTableCell>
                );
            } else if (mode == "custom"){
                if (enabled) {
                    out.push(
                        <StyledTableCell>
                            {this.renderInput({
                            type:"percent",
                            value: this.state.gridValues.occupancy[i],
                            onBlur: (event)=>{
                                this.state.gridValues.occupancy[i] = this.standardizeFormattedNumber(event.target.value);  
                                this.setState({gridValues: this.state.gridValues});
                            }
                            })}
                        </StyledTableCell>
                    );
                } else {
                    out.push(
                    <StyledTableCell>
                        {`${this.state.gridValues.occupancy[i] ? `${(this.state.gridValues.occupancy[i]).toFixed(2)}%` : "-" }`}
                    </StyledTableCell>
                    );
                }
            }
        }
        return out;
    }

    renderDynamicCellsNoiActual = () => {
        const out = [];
        const periodType = this.state.periodType;
        const enabled = this.state.enabled;
        const mode = this.state.mode;
        let numColumns = this.state.term;
        for(let i = 0; i < numColumns; i++){
            if(mode.toLowerCase() == "auto"){
                out.push(
                    <StyledTableCell>
                        {`${this.state.gridValues.noiActual[i] ? `${numberFormatter.formatMoney(this.state.gridValues.noiActual[i].toFixed(2))}` : "-" }`}
                    </StyledTableCell>
                );
            } else if (mode == "custom"){
                if (enabled) {
                    out.push(
                        <StyledTableCell>
                            {this.renderInput({
                            type:"money",
                            value: this.state.gridValues.noiActual[i],
                            onBlur: (event) => {
                                this.state.gridValues.noiActual[i] = this.standardizeFormattedNumber(event.target.value); 
                                this.setState({gridValues: this.state.gridValues});
                            }
                            })}
                        </StyledTableCell>
                    );
                } else {
                    out.push(
                    <StyledTableCell>
                        {`${this.state.gridValues.noiActual[i] ? `${numberFormatter.formatMoney((this.state.gridValues.noiActual[i]).toFixed(2))}` : "-" }`}
                    </StyledTableCell>
                    );
                }
            }
        }
        return out;
    }

    renderDynamicCellsNoiLender = ({padding}) => {
        padding = padding || "";
        const out = [];
        const periodType = this.state.periodType;
        const enabled = this.state.enabled;
        const mode = this.state.mode;
        let numColumns = this.state.term;
        for(let i = 0; i < numColumns; i++){
            if(mode.toLowerCase() == "auto"){
                out.push(
                    <StyledTableCell style={{paddingTop: padding, paddingBottom: padding}}>
                        {`${this.state.gridValues.noiLender[i] ? `${numberFormatter.formatMoney(this.state.gridValues.noiLender[i].toFixed(2))}` : "-" }`}
                    </StyledTableCell>
                );
            } else if (mode == "custom"){
                if (enabled) {
                    out.push(
                        <StyledTableCell>
                            {this.renderInput({
                            type:"money",
                            value: this.state.gridValues.noiLender[i],
                            onBlur: (event)=>{
                                this.state.gridValues.noiLender[i] = this.standardizeFormattedNumber(event.target.value);
                                this.setState({gridValues: this.state.gridValues});
                            }
                            })}
                        </StyledTableCell>
                    );
                } else {
                    out.push(
                    <StyledTableCell>
                        {`${this.state.gridValues.noiLender[i] ? `${numberFormatter.formatMoney((this.state.gridValues.noiLender[i]).toFixed(2))}` : "-" }`}
                    </StyledTableCell>
                    );
                }
            }
        }
        return out;
    }

    renderDSCRRow = ({padding}) => {
        padding = padding || "";
        const out = [];
        const periodType = this.state.periodType;
        const enabled = this.state.enabled;
        const mode = this.state.mode;
        let numColumns = this.state.term;
        for(let i = 0; i < numColumns; i++){
            if(mode.toLowerCase() == "auto"){
                out.push(
                    <StyledTableCell style={{paddingTop: padding, paddingBottom: padding}}>
                        {`${this.state.gridValues.dscrLender[i] ? `${this.state.gridValues.dscrLender[i].toFixed(2)}x` : "-" }`}
                    </StyledTableCell>
                );
            }  else {
                out.push(
                <StyledTableCell>
                    {`${this.state.gridValues.dscrLender[i] ? `${this.state.gridValues.dscrLender[i].toFixed(2)}x` : "-" }`}
                </StyledTableCell>
                );
            } 
        }
        return out;
    }

    renderDebtYieldRow = ({padding}) => {
        padding = padding || "";
        const out = [];
        const periodType = this.state.periodType;
        const enabled = this.state.enabled;
        const mode = this.state.mode;
        let numColumns = this.state.term;
        for(let i = 0; i < numColumns; i++){
            if(mode.toLowerCase() == "auto"){
                out.push(
                    <StyledTableCell style={{paddingTop: padding, paddingBottom: padding}}>
                        {`${this.state.gridValues.debtYield[i] ? `${numberFormatter.formatRate(this.state.gridValues.debtYield[i],2,'--')}` : "-" }`}
                    </StyledTableCell>
                );
            }  else {
                out.push(
                <StyledTableCell>
                    {`${this.state.gridValues.debtYield[i] ? `${numberFormatter.formatRate((this.state.gridValues.debtYield[i]),2,'--')}` : "-" }`}
                </StyledTableCell>
                );
            } 
        }
        return out;
    }

    renderInput = ({type, defaultValue, onChange, onBlur, style, internalLabel, value}) => {
        let inputProps = {
        style:{
            textAlign: "center", 
            transition: '0.3s',
            }
        };
        switch(type){
            case 'money':
                inputProps.inputComponent = DollarAndCentFormat;
                break;   
            case 'percent':
                inputProps.inputComponent = TwoDecimalPercentFormat;
                break;
            case 'integer':
                inputProps.inputComponent = FloatFormat;
            default:
                break;
        }
        return (
            <StyledTextField 
                defaultValue = {defaultValue}
                InputProps = {inputProps}
                onChange = {onChange}
                onBlur = {onBlur}
                label = {internalLabel}
                style={style}
                value = {value}
            />
        )
    }

    hasEditAccess = () => {
        if(this.props.authentication.isGuest){
            if(this.props.isPipeline){
                
                return this.props.activeGuest.pipelinePermissionId === "5aa294ed-3253-11ea-83c9-00ff12c3b408";
            } else {
                return this.props.activeGuest.portfolioPermissionId === "5aa294ed-3253-11ea-83c9-00ff12c3b408";
            }
        } else {
            return true;
        }
    }


}



const mapStateToProps = ({ authentication, deal, properties, guest }) => ({
    authentication,
    propertyAssumptionToken : deal.propertyAssumptionToken,
    extractedProjections: properties.extractedProjections,
    activeGuest: guest.activeGuest,
  });
  
  export default compose(
    connect(mapStateToProps,{
        updatePropertyAssumptions,
        saveCustomProjection,
        downloadProjections,
        clearExtractedProjections
    }),
    withStyles(styles),
  )(PropertyProjectionDashboard);
